
// Global Variables
const desktop = window.matchMedia("(min-width: 1281px)");
const tablet = window.matchMedia("(max-width: 1024px) and (orientation: portrait)");
const scrollElement = window.document.scrollingElement || window.document.body || window.document.documentElement;

module.exports = { desktop, tablet, scrollElement }
